/* eslint-disable @faire/no-re-exports */
export { TestimonialCarousel } from "./TestimonialCarousel";
